import { StandardizedOnboardingData } from "./onboardingDataTransformer";

export const createEmptyStoreData = (): StandardizedOnboardingData => ({
  merchant: {
    name: "",
    nameChinese: "",
    domain: "",
    merchantLogo: undefined,
  },
  store: {
    address: "",
    city: "",
    province: "",
    country: "",
    zip: "",
    phone: "",
    googleMapUrl: "",
    signature: "",
    storeTag: [],
    openingHours: [],
    location: {
      type: "Point",
      coordinates: [0, 0],
    },
  },
  subscription: {
    planId: "free",
    planName: "Free Plan",
  },
  metadata: {
    isFromGoogleApi: false,
    hasGooglePlaceDetails: false,
  },
});
